// extracted by mini-css-extract-plugin
export default {"itemEmptyMessage":"R4Nw21","link":"_Y5VeM","root":"ViFz0J","ellipsis":"PdnFDM","item":"k9Csnz","itemLast":"_R93la"};